import * as React from 'react';
import { Alert as FlowBiteAlert, AlertProps as FlowBiteAlertProps } from 'flowbite-react';
import { buttonTheme } from '../../styles/themes/button';
import { Text } from '../text';
import { ButtonIcon } from '../button-icon';
import { HiX } from 'react-icons/hi';

export type AlertType = 'success' | 'warning' | 'failure' | 'info';

export type AlertProps = Omit<FlowBiteAlertProps, 'label' | 'size' | 'color'> & {
    variant: AlertType;
    title: string;
    text?: string;
    startIcon?: React.ReactNode;
    ariaLabel?: string;
    testId?: string;
    onDismiss?: Function;
    extraContent?: React.ReactNode;
};

export const Alert: React.FC<AlertProps> = (props) => {
    const { title, text, testId, variant, startIcon, onDismiss, extraContent, ariaLabel, ...otherProps } = props;

    return (
        <FlowBiteAlert
            color={variant}
            theme={buttonTheme}
            data-testid={testId}
            aria-label={ariaLabel}
            {...otherProps}
            // this component has two inner divs which need to be full width
            // so we set the direct child's width using [&>*]
            // and then the width of the child's child using [&>*>*]
            className='w-full [&>*>*]:w-full [&>*]:w-full flex-row'
        >
            <div className='flex flex-col p-4 w-full gap-2'>
                <div className='flex flex-row items-center justify-between'>
                    <div className='flex flex-row gap-2 items-center'>
                        {startIcon ? startIcon : null}
                        <Text variant='title-medium'>{title}</Text>
                    </div>

                    {onDismiss && (
                        <ButtonIcon
                            size='md'
                            color={''}
                            onClick={onDismiss as React.MouseEventHandler<HTMLButtonElement>}
                            data-testid={testId + '-close'}
                        >
                            <HiX />
                        </ButtonIcon>
                    )}
                </div>
                {text && <Text variant='body-medium'>{text}</Text>}
                {extraContent && <div className='w-full'>{extraContent}</div>}
            </div>
        </FlowBiteAlert>
    );
};
